<template>
  <div
    ref="modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    @hidden="hidden"
    id="modal-correo"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">
            <b>{{ obj.xtitle }}</b>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">De: </label>
              <div class="col-sm-5"><input class="form-control input-sm" type="text" v-model="decorreo" /></div>
              <!-- <div class="col-sm-5">
                <input class="form-control input-sm" type="password" v-model="declave" placeholder="Contrasena email" />
              </div> -->
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">Asunto: </label>
              <div class="col-sm-10"><input class="form-control input-sm" type="text" v-model="obj.xasunto" /></div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">Mensaje: </label>
              <div class="col-sm-10">
                <small class="text-danger">
                  <b>$nombre, $usuario, $clave, $email y $celu</b> se reemplazan automaticamente con los datos del
                  participante
                </small>
                <ckeditor v-model="obj.xbody" :config="editorConfig"></ckeditor>
                <!-- <textarea class="form-control" type="text" v-model="obj.xbody" rows="7"></textarea> -->
              </div>
            </div>

            <div class="form-group">
              <small class="text-primary">Inscritos: {{ cant_ins }}, Pre inscritos: {{ cant_pre }}</small>
              <label for="inputEmail3" class="col-sm-2 control-label">Tipo: </label>
              <div class="col-sm-10">
                <input type="radio" v-model="tipo_ins" :value="1" @click="filter(1)" /> Inscritos
                <input type="radio" v-model="tipo_ins" :value="2" @click="filter(2)" /> Pre inscritos
                <input type="radio" v-model="tipo_ins" :value="3" @click="filter(3)" /> Todos
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th><small>Nro</small></th>
                      <th><small>Participante</small></th>
                      <th><small>Estado</small></th>
                      <th><small>Datos Moodle</small></th>
                      <th><small>Correo</small></th>
                      <th><small>Reporte</small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="ind" v-for="(e, ind) in estudiantes">
                      <td>
                        <small>{{ ind + 1 }}</small>
                      </td>
                      <td>
                        <small> <input type="checkbox" v-model="e.check" :disabled="loading" /> {{ e.nombres }}</small>
                      </td>
                      <td>
                        <small>{{ e.estado_ins ? 'Inscrito' : 'Preinscrito' }}</small>
                      </td>
                      <td>
                        <small
                          ><b>{{ e.umoodle }}</b> {{ e.cmoodle }}</small
                        >
                      </td>
                      <td>
                        <small><input type="email" v-model="e.email" style="border:0"/></small>
                      </td>
                      <td>
                        <div v-if="e.xestado == '2'" class="loader"></div>
                        <small v-else>{{ e.xestado }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </form>

          <p class="text-center text-danger">{{ msg }}</p>
        </div>

        <Alertas ref="alertar" />
        <div class="modal-footer">
          <button @click="enviarVarios()" :disabled="loading" type="button" class="btn btn-azul">Enviar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cerrar()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
  .loader {
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid blue; /* Blue */
    border-bottom: 4px solid blue;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1.2s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<script>
  import Alertas from '@/components/AAlertas.vue';
  import gql from 'graphql-tag';

  export default {
    props: {
      obj: {
        // {xid:Number,xtitle:String,xbody:String,all:Boolean,isDefault:Boolean,xsql:Object,xcorreo:String,xasunto:String}
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        tipo_ins: 1,
        cant_ins: 0,
        cant_pre: 0,
        activo: true,
        loading: false,
        msg: null,
        estudiantes: [],
        decorreo: process.env.VUE_APP_EMAIL_DEFAUL_CORP,
        declave: process.env.VUE_APP_PASSWORD_DEFAUL_CORP,
        editorData: '<p>Contenido of the editor.</p>',
        editorConfig: {},
        sendEmailsContadorErr: 0,
      };
    },
    watch: {
      'obj.xid': function() {
        if (this.obj.xid == null) return;
        this.$refs.alertar.cargando();
        this.tipo_ins = 1;
        this.cant_ins = 0;
        this.cant_pre = 0;
        //this.activo = false;
        this.editorData = this.obj.xbody;
        this.estudiantes = [];
        this.getEstudiantes();
      },
      obj: function() {
        this.$refs.alertar.reset();
        this.activo = true;
      },
    },
    components: { Alertas },
    methods: {
      hidden() {
        this.$refs.alertar.cargando();
      },
      cerrar() {
        this.obj.xid = null;
        this.obj.xasunto = 'Datos de acceso';
      },
      filter(tipo) {
        this.estudiantes.forEach(function(e) {
          if (tipo == 1)
            if (e.estado_ins == 1) e.check = true;
            else e.check = false;
          else if (tipo == 2)
            if (e.estado_ins == 0) e.check = true;
            else e.check = false;
          else e.check = true;
        });
      },
      getEstudiantes() {
        var vue = this;
        var sql = gql`query{ getPrograma(id:${this.obj.xid}){inscripciones{estado_ins,estudiante{nombres,pri_apellido,seg_apellido,email,telefono1,usuario_moodle,clave_moodle}}} }`;
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var res = data.data.getPrograma.inscripciones;
            var ests = [];
            res.forEach(function(e) {
              var am = e.estudiante.seg_apellido;
              if (!am) am = '';
              if (e.estado_ins == 1) vue.cant_ins += 1;
              else vue.cant_pre += 1;
              var nom = e.estudiante.nombres + ' ' + e.estudiante.pri_apellido + ' ' + am;
              ests.push({
                nombres: nom,
                email: e.estudiante.email,
                telf: e.estudiante.telefono1,
                umoodle: e.estudiante.usuario_moodle,
                cmoodle: e.estudiante.clave_moodle,
                estado_ins: e.estado_ins,
                xestado: null,
                check: e.estado_ins == 1,
              });
            }); //e.estudiante.email
            ests.sort(function(a, b) {
              return b.estado_ins - a.estado_ins;
            });
            vue.estudiantes = ests;

            //   window.console.log(vue.estudiantes);
            vue.$refs.alertar.reset();
          })
          .catch((error) => {
            window.console.error(error);
            vue.$refs.alertar.invalido();
          });
      },
      enviarVarios() {
        if (!this.validar()) {
          return;
        }
        if (this.sendEmailsContadorErr > 2) {
          this.sendEmailsContadorErr = 0;
          this.loading = false;
          return;
        }
        let firtserr = false;
        const vue = this;
        vue.loading = true;
        vue.msg = '';

        this.estudiantes.reduce(async (a, player, i) => {
          await a;
          if (player.check && !firtserr) {
            var body = vue.obj.xbody.replace('\n', ' ');
            body = body + ' ' + player.xlink;
            body = body.replace(/\$nombre/g, player.nombres);
            body = body.replace('$usuario', player.umoodle);
            body = body.replace('$email', player.email);
            body = body.replace('$celu', player.telf);
            body = body.replace('$clave', player.cmoodle);
            body = body.replace('undefined', ' ');
            player.xestado = '2';
            //window.console.log("iniciando 2... ");

            await window.Email.send({
              Host: 'smtp.gmail.com',
              /* Username : "diego.saldias@esam.edu.bo",
                            Password : "rhhailyfijhqxodf", */
              Username: 'desam@esam.edu.bo',
              Password: 'cilkzzjmidixiser',
              //To: 'eclipseconsol@gmail.com',
              To: player.email,
              From: vue.decorreo,
              Subject: vue.obj.xasunto,
              Body: body,
            }).then((message) => {
              window.console.log(message);
              //vue.loading = false;
              player.xestado = message;
              if (message != 'OK') {
                firtserr = true;
                vue.sendEmailsContadorErr += 1;
                vue.enviarVarios();
              } else {
                player.check = false;
                vue.sendEmailsContadorErr = 0;
              }
            });
            //window.console.log("Terminando...");
          }
          if (i == vue.estudiantes.length - 1) vue.loading = false;
        }, Promise.resolve());
      },
      validar() {
        var asu = this.obj.xasunto;
        var men = this.obj.xbody;
        var valido = true;
        if (!asu) {
          this.msg = 'Falta el asunto';
          valido = false;
        } else if (!men) {
          this.msg = 'Falta el mensaje';
          valido = false;
        }
        return valido;
      },
    },
  };
</script>
